// Chart.js 共通設定ユーティリティ
// 全チャートコントローラーからimportして使う

// ツールチップのマーカーに使う凡例アイコン（サーバー生成SVG）を探す。
// 凡例DOMはcanvasのidを data-chart（リーグ詳細の総合pt推移）/ data-chart-id（日別成績）で指し、
// dataset番号を data-index で持つ。SVGをそのまま流用することで、形・線種・色を凡例と必ず一致させる
// （形の生成ロジックは app/helpers/leagues_helper.rb の legend_point_svg が唯一の正）
function legendMarkerSvg(chart, datasetIndex) {
  const canvasId = chart.canvas && chart.canvas.id
  if (!canvasId || datasetIndex == null) return null

  const item = document.querySelector(
    `[data-chart="${canvasId}"][data-index="${datasetIndex}"],` +
    `[data-chart-id="${canvasId}"][data-index="${datasetIndex}"]`
  )
  if (!item) return null

  const svg = item.querySelector('svg.legend-point-icon')

  return svg ? svg.outerHTML : null
}

// カスタムHTMLツールチップ（bar / line 用）
export function externalTooltipHandler(context) {
  const { chart, tooltip } = context
  let el = chart.canvas.parentNode.querySelector('.chart-tooltip')

  if (!el) {
    el = document.createElement('div')
    el.className = 'chart-tooltip'
    Object.assign(el.style, {
      background: '#fff',
      borderRadius: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
      padding: '10px 14px',
      pointerEvents: 'none',
      position: 'absolute',
      transition: 'opacity 0.15s ease',
      fontSize: '13px',
      lineHeight: '1.5',
      zIndex: '50',
      border: '1px solid #E2E8F0'
    })
    chart.canvas.parentNode.style.position = 'relative'
    chart.canvas.parentNode.appendChild(el)
  }

  if (tooltip.opacity === 0) {
    el.style.opacity = '0'
    return
  }

  let html = ''
  if (tooltip.title && tooltip.title.length && tooltip.title[0] !== '') {
    html += `<div style="font-weight:600;color:#1E293B;margin-bottom:4px;font-size:12px">${tooltip.title[0]}</div>`
  }
  if (tooltip.body) {
    tooltip.body.forEach((body, i) => {
      const colors = tooltip.labelColors[i]
      const dataPoint = tooltip.dataPoints[i]
      const isLine = dataPoint.dataset.type === 'line' || chart.config.type === 'line' || chart.config.type === 'radar'
      const dotStyle = isLine
        ? `width:8px;height:8px;border-radius:50%;background:${colors.borderColor};display:inline-block;flex-shrink:0`
        : `width:8px;height:8px;border-radius:2px;background:${colors.backgroundColor.replace(/[\d.]+\)$/, '1)')};display:inline-block;flex-shrink:0`
      // 凡例に形アイコンがあるグラフ（リーグの総合pt推移・日別pt推移）は凡例と同じSVGを出す。
      // それ以外（凡例がチームロゴ・凡例なし）は従来の丸／四角にフォールバックする
      const markerSvg = legendMarkerSvg(chart, dataPoint.datasetIndex)
      html += `<div style="display:flex;align-items:center;gap:8px;color:#64748B">`
      html += markerSvg || `<span style="${dotStyle}"></span>`
      html += `<span>${body.lines.join('')}</span>`
      html += `</div>`
    })
  }
  el.innerHTML = html
  el.style.opacity = '1'
  el.style.transform = ''

  // データポイントの実際のピクセル位置を取得
  const dp = tooltip.dataPoints && tooltip.dataPoints[0]
  const pointX = dp && dp.element ? dp.element.x : tooltip.caretX
  const pointY = dp && dp.element ? dp.element.y : tooltip.caretY

  // チャート描画エリア内に収まるよう位置を調整
  const area = chart.chartArea || {}
  const areaLeft = area.left || 0
  const areaRight = area.right || chart.canvas.parentNode.offsetWidth
  const areaTop = area.top || 0
  const elW = el.offsetWidth
  const elH = el.offsetHeight

  const gap = (tooltip.options && tooltip.options.tooltipGap != null) ? tooltip.options.tooltipGap : 12
  const areaBottom = area.bottom || chart.canvas.parentNode.offsetHeight
  const anchor = (tooltip.options && tooltip.options.tooltipAnchor) || 'top'

  let left, top

  // 水平位置: データポイントの中央揃え、はみ出す場合はクランプ
  left = pointX - elW / 2
  if (left < areaLeft) left = areaLeft
  if (left + elW > areaRight) left = areaRight - elW

  if (anchor === 'bottom') {
    // データポイントの下に配置、はみ出す場合は上
    top = pointY + gap
    if (top + elH > areaBottom) {
      top = pointY - elH - gap
    }
    if (top < areaTop) top = areaTop
  } else {
    // デフォルト: データポイントの上に配置、はみ出す場合は下
    top = pointY - elH - gap
    if (top < areaTop) {
      top = pointY + gap
    }
    if (top + elH > areaBottom) {
      top = areaBottom - elH
    }
  }
  el.style.left = left + 'px'
  el.style.top = top + 'px'
}

// ドーナツ用ツールチップ（labelColors構造が異なる）
export function doughnutTooltipHandler(context) {
  const { chart, tooltip } = context
  let el = chart.canvas.parentNode.querySelector('.chart-tooltip')

  if (!el) {
    el = document.createElement('div')
    el.className = 'chart-tooltip'
    Object.assign(el.style, {
      background: '#fff',
      borderRadius: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
      padding: '10px 14px',
      pointerEvents: 'none',
      position: 'absolute',
      transition: 'opacity 0.15s ease',
      fontSize: '13px',
      lineHeight: '1.5',
      zIndex: '50',
      border: '1px solid #E2E8F0'
    })
    chart.canvas.parentNode.style.position = 'relative'
    chart.canvas.parentNode.appendChild(el)
  }

  if (tooltip.opacity === 0) {
    el.style.opacity = '0'
    return
  }

  let html = ''
  if (tooltip.body) {
    tooltip.body.forEach((body, i) => {
      const dataPoint = tooltip.dataPoints[i]
      const dataset = dataPoint.dataset
      const bgColor = dataset.backgroundColor[dataPoint.dataIndex]
      const total = dataset.data.reduce((sum, val) => sum + val, 0)
      const value = dataPoint.parsed
      const pct = total > 0 ? Math.round(value / total * 100) : 0
      const label = dataPoint.label

      const dotStyle = `width:8px;height:8px;border-radius:50%;background:${bgColor};display:inline-block;flex-shrink:0`
      html += `<div style="display:flex;align-items:center;gap:8px;color:#64748B">`
      html += `<span style="${dotStyle}"></span>`
      html += `<span>${label}: ${value} (${pct}%)</span>`
      html += `</div>`
    })
  }
  el.innerHTML = html
  el.style.opacity = '1'
  el.style.transform = ''

  const containerW = chart.canvas.parentNode.offsetWidth
  const elW = el.offsetWidth
  const elH = el.offsetHeight
  let left = tooltip.caretX - elW / 2
  if (left < 0) left = 0
  if (left + elW > containerW) left = containerW - elW
  el.style.left = left + 'px'

  let top = tooltip.caretY - elH - 12
  if (top < 0) top = tooltip.caretY + 12
  el.style.top = top + 'px'
}

// 共通グリッド設定
export const cleanGridY = {
  color: '#F1F5F9',
  drawTicks: false
}

export const hiddenBorder = {
  display: false
}

// ツールチッププラグイン設定（enabled:falseでexternal使用）
export const tooltipPlugin = {
  enabled: false,
  mode: 'index',
  intersect: false,
  external: externalTooltipHandler
}
